import { atom } from 'recoil';

export const authenticationAtom = atom({
  key: 'AUTHENTICATION_ATOM',
  default: {
    authorized: null,
    bypass: false,
    loading: true,
  },
});
